import React from "react";
import pic2 from "../../assets/svg/car_no_image.jpg";
import FeedbackContext from "../../context/cmscontext";
import { useContext } from "react";
import {
  HiOutlineCalendar,
  HiOutlineChevronRight,
  HiOutlineClock,
  HiOutlineLocationMarker,
} from "react-icons/hi";
import RegPlate from "../RegPlate";
import {
  getAppointmentSummaryParts,
  isPlaceholderAppointmentValue,
  resolveAppointmentStatus,
  formatAppointmentStatusLabel,
  getAppointmentStatusTone,
} from "../../utils/appointmentBooking";
import { resolveEvaluationPlateCountry } from "../../utils/plateCountry";

function Carcard({ item, onClick, mycar, index }) {
  const { feedback } = useContext(FeedbackContext);
  const myAppointment_page = feedback.myAppointment_page || {};

  const imageSrc =
    mycar[index]?.interior_images_?.length > 0
      ? mycar[index].interior_images_[0].image
      : pic2;

  const appointment = Array.isArray(item.appointment)
    ? item.appointment[0]
    : item.appointment;
  const { location, date, time } = getAppointmentSummaryParts(appointment);
  const hasBooking = Boolean(
    appointment?.id || location || date || time
  );
  const appointmentStatus = hasBooking
    ? resolveAppointmentStatus(appointment) || "pending"
    : "";
  const statusTone = hasBooking
    ? getAppointmentStatusTone(appointmentStatus)
    : "none";
  const statusLabel = hasBooking
    ? formatAppointmentStatusLabel(appointment) || "Pending"
    : myAppointment_page.appointment_pending_label || "No booking";
  const reg = item.reg_number || item.car || "";
  const plateCountry = resolveEvaluationPlateCountry({
    plateCountry: item.plate_country || item.Plate_country || item.country,
    evaluation: item,
    reg,
  });
  const vehicleTitle = [item.brand_name, item.model_name, item.year_name]
    .filter(Boolean)
    .join(" ");
  const vehicleMeta = [
    item.variant_name,
    item.fuel_type,
    item.Mileage ? `${item.Mileage} km` : "",
  ]
    .filter(Boolean)
    .join(" · ");

  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick?.();
    }
  };

  return (
    <article
      className="pi-appointment-card pi-appointment-card--row"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
    >
      <div className="pi-appointment-card__media">
        <img
          className="pi-appointment-card__image"
          src={imageSrc}
          alt={vehicleTitle || "Vehicle"}
          loading="lazy"
        />
      </div>

      <div className="pi-appointment-card__body">
        <div className="pi-appointment-card__head">
          <div className="pi-appointment-card__identity">
            {reg ? (
              <RegPlate
                value={reg}
                country={plateCountry}
                className="pi-appointment-card__plate"
              />
            ) : null}
            <div className="pi-appointment-card__titles">
              <h3 className="pi-appointment-card__title">
                {vehicleTitle || item.brand_name || "Your vehicle"}
              </h3>
              {vehicleMeta ? (
                <p className="pi-appointment-card__subtitle">{vehicleMeta}</p>
              ) : null}
            </div>
          </div>
          <span
            className={`pi-appointment-card__status pi-appointment-card__status--${statusTone}`}
          >
            {statusLabel}
          </span>
        </div>

        {hasBooking ? (
          <div className="pi-appointment-card__chips">
            {location ? (
              <span className="pi-appointment-card__chip">
                <HiOutlineLocationMarker size={14} aria-hidden />
                {location}
              </span>
            ) : null}
            {date && !isPlaceholderAppointmentValue(date) ? (
              <span className="pi-appointment-card__chip">
                <HiOutlineCalendar size={14} aria-hidden />
                {date}
              </span>
            ) : null}
            {time && !isPlaceholderAppointmentValue(time) ? (
              <span className="pi-appointment-card__chip">
                <HiOutlineClock size={14} aria-hidden />
                {time}
              </span>
            ) : null}
          </div>
        ) : (
          <p className="pi-appointment-card__hint">
            {myAppointment_page.no_appointment_yet ||
              "No inspection booked yet — open to complete your profile."}
          </p>
        )}

        {item.tracking_number ? (
          <p className="pi-appointment-card__tracking">
            <span>{myAppointment_page.tracking_label || "Tracking"}</span>
            <strong>{item.tracking_number}</strong>
          </p>
        ) : null}
      </div>

      <div className="pi-appointment-card__action" aria-hidden>
        <span className="pi-appointment-card__action-label">
          {myAppointment_page.view_details_label || "Open"}
        </span>
        <span className="pi-appointment-card__chevron">
          <HiOutlineChevronRight size={20} />
        </span>
      </div>
    </article>
  );
}

export default Carcard;
